import React from 'react'
import styled from 'styled-components'
import OrderSummaryItem from '../../../components/order-summary-item/order-summary-item.component.jsx'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import BusSeatSelectionSelectors from '../../../selectors/bus-seat-selection.selectors'
import { connect } from 'react-redux'
import { GREEN, LIGHTGRAY } from '../../../styles/colors.style'
import { breakpoints } from '../../../constants'
import { bindActionCreators } from 'redux'
import { Creators as TicketSaleCreators } from '../../../ducks/ticket-sale/ticket-sale'
import TicketSaleService from './../../../services/ticket-sale.service'
import TripPriceHelper from '../../../helpers/trip-price.helper'
import { groupTrips } from '../../../helpers'
import { resolvePointsRebooking, resolvePayableTotal } from '../../../helpers/checkout.helper'
import CreditCardPurchaseSelectors from '../../../ducks/credit-card-purchase/credit-card-purchase.selectors'
import MuvicardPurchaseSelectors from '../../../ducks/muvicard-purchase/muvicard-purchase.selectors'
import { PAYMENT_METHODS } from '../../../constants'
import ReactTooltip from 'react-tooltip'
import FontAwesome from 'react-fontawesome'
import { SectionTitle } from './common'
import { SkeletonPartialSeatsCalcutatedSelection } from './skeletons/skeleton-partial-calculated-values'

const SINGLE_TRIP = 1

class OrderSummaryComponent extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			muvicardDiscountParameters: {},
		}
	}

	async componentDidUpdate(prevProps) {
		if (this.props.muvicardCpf !== prevProps.muvicardCpf) {
			let params = { cpf: this.props.muvicardCpf }
			await TicketSaleService.getMuvicardDiscountParameters(params).then(
				({ success, data }) => {
					if (success) {
						this.setState({ muvicardDiscountParameters: data })
					}
				}
			)
		}
	}

	render() {
		const {
			user,
			conexao,
			isRebooking,
			rebookingTicketValue,
			rebookingTicketPoints,
			calculatedValues,
			hasValueToRefund,
			totalValue,
			setTotalPointsOnTicketSale,
			isCalculatingValues,
		} = this.props

		if (!this.props.isEtapaPagamento) {
			return <div />
		}

		const {
			ticketsGoing,
			ticketsReturn,
			totalConvenienceFee,
			totalDiscount,
			totalFare,
			totalFeeSummary,
			subtotalValue,
			feesIncludedInSubtotal,
			totalInsuranceValue,
			totalInsurancePoints,
			totalPointsForConvenienceFee,
			totalPointsUsed,
			rebookingContext,
		} = calculatedValues

		// "Bilhete original" prefere o valor vindo do carrinho (Spec remarcacao-cart-context,
		// atualizado a cada poltrona) - só cai pro Redux congelado (rebookingValue/rebookingPoints
		// do clique em "Remarcar") quando o carrinho ainda não tem o contexto de remarcação.
		const originalTicketValue = rebookingContext
			? rebookingContext.originalTicketValue
			: rebookingTicketValue
		// Bug 8002: crédito e diferença em pontos pelo mesmo helper do modal de poltronas.
		const {
			originalTicketPoints,
			pointsDifference: totalPointsRebooking,
			hasPointsToRefund,
		} = resolvePointsRebooking({
			rebookingContext,
			isRebooking,
			rebookingTicketPoints,
			totalPointsUsed,
		})

		const isPublicBody = user && user.hasPublicBody

		setTotalPointsOnTicketSale(totalPointsUsed)

		const hasPlusSign = totalValue > 0 && totalPointsUsed > 0 ? ' + ' : ''

		// Reteste 2 (O2): o total a pagar acompanha a parcela escolhida (juros do parcelamento e desconto do meio,
		// como na confirmação e no displayedTotal enviado ao checkout).
		const { payableTotal, installmentInterest, paymentDiscount } = resolvePayableTotal({
			totalValue,
			hasValueToRefund,
			paymentMethod: this.props.paymentMethod,
			user,
			creditCardInstallments: this.props.creditCardInstallmentsQtt,
			muvicardInstallments: this.props.muvicardInstallmentsQtt,
			installmentsOptions: this.props.installmentsOptions,
			muvicardInstallmentsOptions: this.props.muvicardInstallmentsOptions
		})

		const trechosAgrupadosIda = groupTrips(ticketsGoing)
		let trechosAgrupadosVolta = null

		if (ticketsReturn) {
			trechosAgrupadosVolta = groupTrips(ticketsReturn)
		}

		const msgServiceCharge =
			'Através desta taxa podemos prover tecnologia para você garantiar sua passagem de ônibus online e com antecedência: )'

		return (
			<div>
				{!!ticketsReturn.length && <SectionTitle title="Ida" />}
				{!!conexao.conexaoIda
					? trechosAgrupadosIda.map(([key, value]) => (
							<div id={key}>
								<OrderSummaryItem
									origin={value[0].conexao.origin}
									destination={value[0].conexao.destination}
									busSeats={value}
								/>
							</div>
					  ))
					: !!ticketsGoing.length &&
					  this.props.isEtapaPagamento && (
							<OrderSummaryItem
								origin={this.props.originGoing}
								destination={this.props.destinationGoing}
								busSeats={ticketsGoing}
							/>
					  )}

				{!!ticketsReturn.length && <SectionTitle title="Volta" />}

				{!!conexao.conexaoVolta
					? trechosAgrupadosVolta.map(([key, value]) => {
							return (
								<div id={key}>
									<OrderSummaryItem
										origin={value[0].conexao.origin}
										destination={value[0].conexao.destination}
										busSeats={value}
									/>
								</div>
							)
					  })
					: !!ticketsReturn.length && (
							<React.Fragment>
								<br />
								<OrderSummaryItem
									origin={this.props.originReturn}
									destination={this.props.destinationReturn}
									busSeats={ticketsReturn}
								/>
							</React.Fragment>
					  )}
				<StyledValuesContainer>
					<div className="content">
						{isCalculatingValues ? (
							<StyledCalculatedValuesArea>
								<SkeletonPartialSeatsCalcutatedSelection />
							</StyledCalculatedValuesArea>
						) : (
							<React.Fragment>
								<StyledValue>
									<span>Subtotal</span>
									<span>
										{totalPointsUsed > 0
											? `${totalPointsUsed.toLocaleString(
													'pt-BR'
											  )} pts `
											: ''}
										{hasPlusSign}
										{`${subtotalValue.$toReais()}`}
									</span>
								</StyledValue>

								{!isPublicBody &&
									!feesIncludedInSubtotal &&
									totalFeeSummary > 0 && (
									<StyledValue>
										<span>Taxas, Impostos e Pedágios</span>
										<span>{totalFeeSummary.$toReais()}</span>
									</StyledValue>
								)}

								{!isPublicBody && (totalInsuranceValue > 0 || totalInsurancePoints > 0) && (
									<StyledValue data-testid="order-summary-insurance">
										<span>Seguro</span>
										<span>
											{totalInsurancePoints > 0 && `${totalInsurancePoints.toLocaleString('pt-BR')} pts`}
											{totalInsurancePoints > 0 && totalInsuranceValue > 0 && ' + '}
											{totalInsuranceValue > 0 && totalInsuranceValue.$toReais()}
										</span>
									</StyledValue>
								)}

								{!isPublicBody && totalConvenienceFee > 0 && (
									<StyledValue>
										<span>
											Taxa de Serviço{' '}
											<FontAwesome
												name="info-circle"
												data-for="servicecharge-tooltip"
												data-tip="true"
												data-multiline="true"
												data-html="true"
											/>
										</span>
										<span>{totalConvenienceFee.$toReais()}</span>
										<ReactTooltip
											id="servicecharge-tooltip"
											aria-haspopup="true"
											effect="solid"
											place="bottom">
											{msgServiceCharge}
										</ReactTooltip>
									</StyledValue>
								)}

								{isRebooking && (
									<StyledValue>
										<span style={{ color: GREEN }}>
											Bilhete original
										</span>
										<span
											style={{
												color: GREEN,
											}}>
											{' '}
											{originalTicketPoints > 0
												? `${originalTicketPoints.toLocaleString(
														'pt-BR'
												  )} pts + `
												: ' -'}
											{`${originalTicketValue.$toReais()}`}
										</span>
										<ReactTooltip
											id="servicecharge-tooltip"
											aria-haspopup="true"
											effect="solid"
											place="bottom">
											{msgServiceCharge}
										</ReactTooltip>
									</StyledValue>
								)}

								{!isPublicBody && totalPointsForConvenienceFee > 0 && (
									<StyledValue>
										<span>
											Taxa de Serviço{' '}
											<FontAwesome
												name="info-circle"
												data-for="servicecharge-tooltip"
												data-tip="true"
												data-multiline="true"
												data-html="true"></FontAwesome>
										</span>
										<span>{`${totalPointsForConvenienceFee} pts `}</span>
										<ReactTooltip
											id="servicecharge-tooltip"
											aria-haspopup="true"
											effect="solid"
											place="bottom">
											{msgServiceCharge}
										</ReactTooltip>
									</StyledValue>
								)}

								{!isPublicBody && totalDiscount > 0 && (
									<StyledValue>
										<span style={{ color: GREEN }}>Descontos</span>
										<span style={{ color: GREEN }}>
											{<span>-{totalDiscount.$toReais()}</span>}
										</span>
									</StyledValue>
								)}

								{installmentInterest > 0 && (
									<StyledValue>
										<span>Juros do parcelamento</span>
										<span>{installmentInterest.$toReais()}</span>
									</StyledValue>
								)}

								{paymentDiscount > 0 && (
									<StyledValue>
										<span style={{ color: GREEN }}>Desconto do meio de pagamento</span>
										<span style={{ color: GREEN }}>-{paymentDiscount.$toReais()}</span>
									</StyledValue>
								)}

								<hr />

								<StyledValue>
									<span style={{ fontWeight: 'bold' }}>
										Total
										{`${
											isRebooking && hasValueToRefund
												? ' a estornar'
												: ' a pagar'
										}`}
									</span>
									<span style={{ fontWeight: 'bold' }}>
										{!isRebooking && totalPointsUsed > 0 ? (
											<span>
												{totalPointsUsed.toLocaleString('pt-BR')}{' '}
												pts  {hasPlusSign}{' '}
											</span>
										) : null}
										{<span>{payableTotal.$toReais()}</span>}
									</span>
								</StyledValue>
								<StyledValue>
									{/* Pontos remarcação */}
									{isRebooking && totalPointsRebooking !== 0 && (
										<React.Fragment>
											<span style={{ fontWeight: 'bold' }}>
												Total Pontos{' '}
												{hasPointsToRefund
													? 'a estornar'
													: 'a pagar'}
											</span>
											<span
												style={{
													fontWeight: 'bold',
													color:
														totalPointsRebooking > 0
															? GREEN
															: '',
												}}>
												{/* O rótulo já diz "a pagar"/"a estornar" - como o total em reais, sem sinal. */}
												{`${Math.abs(totalPointsRebooking).toLocaleString(
													'pt-BR'
												)} pts `}
											</span>
										</React.Fragment>
									)}
								</StyledValue>
							</React.Fragment>
						)}
					</div>
				</StyledValuesContainer>
			</div>
		)
	}
}

const StyledValuesContainer = styled.div`
	display: flex;
	justify-content: flex-end;

	.content {
		border-top: 1px solid ${LIGHTGRAY};
		display: inline-block;
		margin-top: 15px;
		padding-top: 5px;
		width: 100%;
	}
`

const StyledCalculatedValuesArea = styled.div`
	width: 100%;
`

const StyledValue = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 1.7rem;
	width: 100%;

	span:first-child {
		text-align: left;
		flex: 1;
	}

	span:last-child {
		text-align: right;
	}
`

const mapStateToProps = (store) => ({
	user: store.user,
	originGoing: store.ticketSale.originGoing,
	destinationGoing: store.ticketSale.destinationGoing,
	originReturn: store.ticketSale.originReturn,
	destinationReturn: store.ticketSale.destinationReturn,
	isRebooking: store.ticketSale.rebookingData.isRebooking,
	rebookingTicketValue: store.ticketSale.rebookingData.rebookingValue,
	rebookingTicketPoints: store.ticketSale.rebookingData.rebookingPoints,
	isPaymentStep: TicketSaleSelectors.isPaymentStep(store),
	tripPriceGoing: TicketSaleSelectors.getTripPriceGoing(store),
	tripPriceReturn: TicketSaleSelectors.getTripPriceReturn(store),
	tripGoingSummary: TicketSaleSelectors.getTripGoingSummary(store),
	tripReturnSummary: TicketSaleSelectors.getTripReturnSummary(store),
	isEtapaPagamento: TicketSaleSelectors.getEtapaPagamento(store),
	selectedPoltonasIda: BusSeatSelectionSelectors.getSelectedViagemIda(
		store.busSeatSelection
	),
	conexao: store.conexao,
	calculatedValues: TicketSaleSelectors.getCalculatedValues(store),
	familyDiscountParameters:
		TicketSaleSelectors.getFamilyDiscountParameters(store),
	familyDiscountApplied: store.ticketSale.familyDiscountApplied,
	isCalculatingValues: store.ticketSale.isCalculatingValues,
	paymentMethod: store.ticketSale.paymentMethod,
	installmentsOptions: CreditCardPurchaseSelectors.getInstallmentsOptions(store.creditCardPurchase),
	creditCardInstallmentsQtt: CreditCardPurchaseSelectors.getInstallmentsQtt(store.creditCardPurchase),
	muvicardInstallmentsOptions: MuvicardPurchaseSelectors.getMuvicardInstallmentsOptions(store.muvicardPurchase),
	muvicardInstallmentsQtt: MuvicardPurchaseSelectors.getMuvicardInstallmentsQtt(store.muvicardPurchase),
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getServiceCharge: TicketSaleCreators.getServiceCharge,
			setTotalPointsOnTicketSale: TicketSaleCreators.totalPointsOnTicketSale,
		},
		dispatch
	)

const OrderSummary = connect(
	mapStateToProps,
	mapDispatchToProps
)(OrderSummaryComponent)

export default OrderSummary
